export default __webpack_public_path__ + "static/media/albert_icon_login.8ff570fb.svg";